const defaultDateFields = ['fiscal_year_end', 'founded_at'];
const defaultNumberFields = [
    'exact_annual_revenue',
    'exact_company_size',
    'game_plan_grants_analyzed',
    'lat',
    'lng',
];
export const companyPatchComparableFromCompany = (company) => (Object.assign(Object.assign({}, company), { industry_icnpo_id: company.industries_icnpo, npo_beneficiaries_id: company.npo_beneficiaries, npo_scopes_id: company.npo_scopes }));
const companyPatchFrontendFields = [
    {
        patchField: 'address',
        client: true,
        adminForm: true,
        providerFormFields: ['company_address'],
    },
    {
        patchField: 'annual_revenue',
        client: true,
        adminForm: true,
        providerFormFields: ['annual_revenue', 'company_annual_revenue'],
    },
    {
        patchField: 'business_number',
        adminForm: true,
        providerFormFields: ['business_number'],
    },
    {
        patchField: 'charity_number',
        client: true,
        adminForm: true,
        providerFormFields: ['charity_number'],
    },
    {
        patchField: 'city',
        client: true,
        adminForm: true,
        providerFormFields: ['company_city'],
    },
    { patchField: 'comments', adminForm: true, providerFormFields: ['comments'] },
    { patchField: 'company_tag_goals', client: true, adminForm: true },
    {
        patchField: 'country',
        client: true,
        adminForm: true,
        providerFormFields: ['company_country'],
    },
    {
        patchField: 'cra_number',
        adminForm: true,
        providerFormFields: ['cra_number'],
    },
    { patchField: 'account_classification', adminForm: true },
    {
        patchField: 'description',
        client: true,
        providerFormFields: ['company_description'],
    },
    {
        patchField: 'email',
        client: true,
        adminForm: true,
        providerFormFields: ['company_email'],
    },
    { patchField: 'exact_annual_revenue', client: true, adminForm: true },
    { patchField: 'exact_company_size', client: true, adminForm: true },
    { patchField: 'facebook', client: true, providerFormFields: ['facebook'] },
    {
        patchField: 'fiscal_year_end',
        client: true,
        adminForm: true,
        providerFormFields: ['fiscal_year_end'],
    },
    {
        patchField: 'founded_at',
        client: true,
        adminForm: true,
        providerFormFields: ['company_founded_at'],
    },
    {
        patchField: 'industry',
        client: true,
        providerFormFields: ['company_industry', 'industry'],
    },
    { patchField: 'industry_icnpo_id', client: true, adminForm: true },
    { patchField: 'industry_sector', client: true, adminForm: true },
    { patchField: 'industry_subsector', client: true, adminForm: true },
    { patchField: 'instagram', client: true, providerFormFields: ['instagram'] },
    {
        patchField: 'lat',
        client: true,
        adminForm: true,
        providerFormFields: ['lat'],
    },
    { patchField: 'legal_structure', client: true, adminForm: true },
    { patchField: 'linked_in', client: true, providerFormFields: ['linked_in'] },
    {
        patchField: 'lng',
        client: true,
        adminForm: true,
        providerFormFields: ['lng'],
    },
    { patchField: 'naics_code', client: true, adminForm: true },
    {
        patchField: 'name',
        client: true,
        adminForm: true,
        providerFormFields: ['company_name'],
    },
    { patchField: 'npo_beneficiaries_id', client: true, adminForm: true },
    { patchField: 'npo_scopes_id', client: true, adminForm: true },
    { patchField: 'npo_stream_id', client: true, adminForm: true },
    {
        patchField: 'phone',
        client: true,
        adminForm: true,
        providerFormFields: ['company_phone'],
    },
    { patchField: 'pinterest', client: true, providerFormFields: ['pinterest'] },
    {
        patchField: 'postal_code',
        client: true,
        adminForm: true,
        providerFormFields: ['company_postal_code'],
    },
    {
        patchField: 'profile_language',
        client: true,
        adminForm: true,
        providerFormFields: ['profile_language'],
    },
    { patchField: 'program_description', client: true, adminForm: true },
    {
        patchField: 'project_language',
        client: true,
        providerFormFields: [
            'project_language',
            { sourceField: 'rfp_language', currentField: 'rfp_language' },
        ],
    },
    {
        patchField: 'province',
        client: true,
        adminForm: true,
        providerFormFields: ['company_province'],
    },
    {
        patchField: 'size',
        client: true,
        adminForm: true,
        providerFormFields: ['company_size'],
    },
    {
        patchField: 'tagline',
        client: true,
        providerFormFields: ['company_tagline', 'tagline'],
    },
    { patchField: 'tiktok', client: true, providerFormFields: ['tiktok'] },
    { patchField: 'twitter', client: true, providerFormFields: ['twitter'] },
    {
        patchField: 'website',
        client: true,
        adminForm: true,
        providerFormFields: ['company_website'],
    },
    { patchField: 'youtube', client: true, providerFormFields: ['youtube'] },
];
const buildCompanyPatchFieldList = (isIncluded) => companyPatchFrontendFields
    .filter(isIncluded)
    .map(({ patchField }) => patchField);
export const clientCompanyPatchFields = buildCompanyPatchFieldList(({ client }) => !!client);
export const adminCompanyPatchFields = buildCompanyPatchFieldList(({ adminForm }) => !!adminForm);
export const providerCompanyPatchFieldMap = companyPatchFrontendFields.reduce((fieldMap, { patchField, providerFormFields }) => {
    providerFormFields === null || providerFormFields === void 0 ? void 0 : providerFormFields.forEach((providerFormField) => {
        if (typeof providerFormField === 'string') {
            fieldMap[providerFormField] = { patchField };
            return;
        }
        fieldMap[providerFormField.sourceField] = {
            patchField,
            currentField: providerFormField.currentField,
        };
    });
    return fieldMap;
}, {});
const makeFieldSet = (defaults, fields) => new Set(fields !== null && fields !== void 0 ? fields : defaults);
const buildCompanyPatchFromFieldEntries = (values, current, entries, options = {}) => {
    const patch = {};
    const patchRecord = patch;
    const valueRecord = values;
    const currentRecord = current;
    entries.forEach(({ sourceField, patchField, currentField }) => {
        if (!Object.prototype.hasOwnProperty.call(valueRecord, sourceField)) {
            return;
        }
        const nextValue = valueRecord[sourceField];
        const currentValue = currentRecord[currentField !== null && currentField !== void 0 ? currentField : patchField];
        if (areCompanyPatchValuesEqual(patchField, nextValue, currentValue, options)) {
            return;
        }
        patchRecord[patchField] = normalizeCompanyPatchRequestValue(patchField, nextValue, options);
    });
    return patch;
};
export const normalizeCompanyPatchComparable = (field, value, options = {}) => {
    if (value === undefined || value === null || value === '') {
        return null;
    }
    if (Array.isArray(value)) {
        return value
            .map((item) => (typeof item === 'string' ? item.trim() : String(item)))
            .filter((item) => item !== '')
            .sort();
    }
    if (makeFieldSet(defaultNumberFields, options.numberFields).has(field)) {
        const numberValue = Number(value);
        return Number.isFinite(numberValue) ? numberValue : value;
    }
    if (makeFieldSet(defaultDateFields, options.dateFields).has(field)) {
        const timestamp = Date.parse(String(value));
        return Number.isNaN(timestamp) ? value : new Date(timestamp).toISOString();
    }
    return value;
};
export const areCompanyPatchValuesEqual = (field, nextValue, currentValue, options = {}) => JSON.stringify(normalizeCompanyPatchComparable(field, nextValue, options)) ===
    JSON.stringify(normalizeCompanyPatchComparable(field, currentValue, options));
export const normalizeCompanyPatchRequestValue = (field, value, options = {}) => {
    if (value === undefined || value === null) {
        return null;
    }
    const numberFields = makeFieldSet(defaultNumberFields, options.numberFields);
    const dateFields = makeFieldSet(defaultDateFields, options.dateFields);
    if (typeof value === 'string' && value.trim() === '') {
        return numberFields.has(field) || dateFields.has(field) ? null : value;
    }
    if (dateFields.has(field)) {
        if (value instanceof Date) {
            return value.toISOString();
        }
        if (typeof value.toISOString === 'function') {
            return value.toISOString();
        }
    }
    if (numberFields.has(field)) {
        const numberValue = Number(value);
        return Number.isFinite(numberValue) ? numberValue : value;
    }
    return value;
};
export const buildCompanyPatchFromValues = (values, current, fieldMap, options = {}) => buildCompanyPatchFromFieldEntries(values, current, Object.entries(fieldMap).map(([sourceField, config]) => ({
    sourceField,
    patchField: config.patchField,
    currentField: config.currentField,
})), options);
export const buildCompanyPatchFromMatchingFields = (values, current, fields, options = {}) => buildCompanyPatchFromFieldEntries(values, current, fields.map((field) => ({
    sourceField: field,
    patchField: field,
})), options);
export const buildCompanyPatchFromFormData = (data, current, fieldMap, options = {}) => {
    const rawRequest = data.get('request');
    if (typeof rawRequest !== 'string') {
        return {};
    }
    const values = JSON.parse(rawRequest);
    return buildCompanyPatchFromValues(values, current, fieldMap, options);
};
export const buildCompanyPatchFromFormDataMatchingFields = (data, current, fields, options = {}) => {
    const rawRequest = data.get('request');
    if (typeof rawRequest !== 'string') {
        return {};
    }
    const values = JSON.parse(rawRequest);
    return buildCompanyPatchFromMatchingFields(values, current, fields, options);
};
export const buildTouchedCompanyPatchFromFields = (values, isFieldTouched, fields, options = {}) => {
    const patch = {};
    const patchRecord = patch;
    fields.forEach(({ formField, patchField, serialize }) => {
        if (!isFieldTouched(formField)) {
            return;
        }
        const value = values[formField];
        patchRecord[patchField] = serialize
            ? serialize(value)
            : normalizeCompanyPatchRequestValue(patchField, value, options);
    });
    return patch;
};
export const buildTouchedCompanyPatchFromMatchingFields = (values, isFieldTouched, fields, options = {}) => buildTouchedCompanyPatchFromFields(values, isFieldTouched, fields.map((field) => ({
    formField: field,
    patchField: field,
})), options);
